<template>
    <div class="join_us_en_div">
        <div>
            <div class="join_banner">
                <img :src="imgSrc[0]"/>
            </div>
            <div class="allContentWidth">
                <div class="join_dz_title">
                    <div class="join_dz_img">
                        <!-- <img :src="imgSrc[1]"/> -->
                        <p>Welcome to join Eastrong</p>
                        <div class="line_div_box"></div>
                    </div>
                </div>
                <div class="filtrate_div">
                    <div class="workplace_style">
                        <span>Working place：</span>
                        <!-- @on-change="workplaceChangeFun" -->
                        <Select v-model="workplace" style="width:220px!important;">
                            <Option v-for="item in workplaceList" :value="item.value" :key="item.value">{{
                                item.label
                                }}
                            </Option>
                        </Select>
                    </div>
                    <div>
                        <span>Position：</span>
                        <Select v-model="position" style="width:220px!important" @on-change="positionChangeFun">
                            <Option v-for="item in positionList" :value="item.value" :key="item.value">{{
                                item.label
                                }}
                            </Option>
                        </Select>
                    </div>
                </div>
                <div class="table_job_div">
                    <div class="job_box">
                        <span>Position</span>
                        <span>Working place</span>
                        <span>Deliver mailbox</span>
                    </div>
                    <Collapse v-model="value2" class="collapse_box">
                        <Panel v-for="item in joinFilter" :key="item.zw_title" :name="item.zw_title" class="panel_s">
                            <span class="title_span_s"><b>{{ item.zw_title }}</b><b>{{ item.job_place }}</b><b>{{ item.send_email }}</b></span>
                            <div slot="content">
                                <div class="join_job_duty_condition_box">
                                    <div class="join_left">
                                        <span class="duty_condition_title">Job Responsibilities:</span>
                                        <p v-for="j in item.job_duties" :key="j.key">
                                            {{ `${j.key}、${j.value}；` }}
                                        </p>
                                    </div>
                                    <div class="join_right">
                                        <span class="duty_condition_title">Qualifications:</span>
                                        <p v-for="r in item.job_condition" :key="r.key">
                                            {{ `${r.key}、${r.value}；` }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                    </Collapse>
                </div>
                <div class="table_job_div_mobile">
                    <div class="job_box">
                        <span>Position</span>
                    </div>
                    <Collapse v-model="value2" class="collapse_box">
                        <Panel v-for="item in joinFilter" :key="item.zw_title" :name="item.zw_title" class="panel_s">
                            <span class="title_span_s"><b>{{ item.zw_title }}</b></span>
                            <div slot="content">
                                <div>
                                    <span>Working place: </span> <b>{{ item.job_place }}</b>
                                </div>
                                <div class="email_div">
                                    Deliver mailbox: <b>{{ item.send_email }}</b>
                                </div>
                                <div class="join_job_duty_condition_box">
                                    <div class="join_left">
                                        <span class="duty_condition_title">Job Responsibilities:</span>
                                        <p v-for="j in item.job_duties" :key="j.key">
                                            {{ `${j.key}、${j.value}；` }}
                                        </p>
                                    </div>
                                    <div class="join_right">
                                        <span class="duty_condition_title">Qualifications:</span>
                                        <p v-for="r in item.job_condition" :key="r.key">
                                            {{ `${r.key}、${r.value}；` }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                    </Collapse>
                </div>
                <!-- <div class="join_content">
                    <div class="join_con_div" v-for="item in joinArr" :key="item.id">
                        <div class="join_job_title_box">
                            <div class="join_job_title">
                                <div class="join_line_div"></div>
                                <p>Position： {{item.zw_title}}</p>
                            </div>
                            <div class="join_workplace_email_div">
                                <span class="join_workplace_text">Working place: {{item.job_place}}</span>
                                <span>Deliver mailbox：{{item.send_email}}</span>
                            </div>
                        </div>
                        <div class="join_job_duty_condition_box">
                            <div class="join_left">
                                <span class="duty_condition_title">Job Responsibilities：</span>
                                <p v-for="j in item.job_duties" :key="j.key">
                                    {{`${j.key}、${j.value}；`}}
                                </p>
                            </div>
                            <div class="join_right">
                                <span class="duty_condition_title">Qualifications：</span>
                                <p v-for="r in item.job_condition" :key="r.key">
                                    {{`${r.key}、${r.value}；`}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {},
    computed: {},
    mounted() {
        this.positionChangeFun('all');
    },
    watch: {},
    methods: {
        positionChangeFun(val) {
            var list = [...this.joinArr];
            if (val !== 'all') {
                var arr = [];
                list.map((item) => {
                    if (item.zw_title === val) {
                        arr.push(item);
                    }
                })
                this.joinFilter = arr;
            } else {
                this.joinFilter = list;
            }
        },
    },
    data() {
        var imgSrc = [];
        imgSrc.push(require('../../assets/img/shi1.png'));//(0)
        imgSrc.push(require('../../assets/img/joinUs/dongzhi_title_en.png'));//(1)
        return {
            imgSrc: imgSrc,
            value2: '',//海运单证
            workplace: 'all',
            workplaceList: [
                {value: 'all', label: 'all'},
                {value: 'Shanghai', label: 'Shanghai'},
                {value: 'Ningbo', label: 'Ningbo'},
                {value: 'Guangzhou', label: 'Guangzhou'},
                {value: 'Shenzhen', label: 'Shenzhen'},
                {value: 'Xiamen', label: 'Xiamen'},
                {value: 'Qingdao', label: 'Qingdao'},
                // {value: '深圳',label: '深圳'},
            ],
            position: 'all',
            positionList: [
                {value: 'all', label: 'all'},
                {value: 'Ocean Freight documentation', label: 'Ocean Freight documentation'},
                {value: 'Ocean Freight Operations', label: 'Ocean Freight Operations'},
                {value: 'Intern', label: 'Intern'},
            ],
            joinFilter: [],
            joinArr: [
                {
                    id: 1,
                    zw_title: 'Ocean Freight documentation',
                    job_place: 'Shanghai',
                    send_email: 'janeca@eastrongintl.com',
                    job_duties: [
                        {key: 1, value: 'Make a sea BOL and provide it to customers for verification and confirmation'},
                        {key: 2, value: 'Verification and settlement of expenses'},
                        {key: 3, value: 'Assist in the operation and processing of documents'},
                        {key: 4, value: 'Processing and archiving of relevant forms, documents'},
                        {
                            key: 5,
                            value: 'Maintain a good communication relationship with the consignor, the destination port agent and the supplier'
                        },
                        {key: 6, value: 'Complete other related work arranged by the superior'},
                    ],
                    job_condition: [
                        {key: 1, value: 'Full-time college degree or above, open to fresh graduates'},
                        {key: 2, value: 'Capable of export documents of shipping business'},
                        {key: 3, value: 'Proficient in the use of various office software and automation equipment'},
                        {key: 4, value: 'Basic literacy skills in English, CET- 4 or above is preferred'},
                        {key: 5, value: 'Work enthusiastically as a team with office colleagues'},
                    ],
                },
                {
                    id: 2,
                    zw_title: 'Ocean Freight Operations',
                    job_place: ' Shanghai',
                    send_email: 'janeca@eastrongintl.com',
                    job_duties: [
                        {key: 1, value: 'Familiar with the import and export business process of shipping'},
                        {
                            key: 2,
                            value: 'Be able to independently handle booking, letter of support, system entry, arrange warehousing, box making, trailer customs declaration and other matters'
                        },
                        {
                            key: 3,
                            value: 'Keep close contact with agents, shipping companies, customs declaration, customers, etc.'
                        },
                        {
                            key: 4,
                            value: 'Responsible for the collation and archiving of operational documents, sending pre-alert and express invoices and chargebacks'
                        },
                        {
                            key: 5,
                            value: 'Deal with customer complaints, dispute handling and other related work assigned by superiors'
                        },
                    ],
                    job_condition: [
                        {key: 1, value: 'Full-time college degree or above'},
                        {
                            key: 2,
                            value: 'More than 3 years of operation experience in logistics enterprises, proficient in the operation process of ocean freight import and export, monitor whole process. With the experience of operating customers is preferred'
                        },
                        {key: 3, value: 'Basic literacy skills in English, preferably at the CET- 4 or above'},
                        {
                            key: 4,
                            value: 'Careful work, strong sense of responsibility, strong sense of service and team spirit'
                        },
                        {
                            key: 5,
                            value: 'Strong sense of service, able to withstand certain work pressure, and good at dealing with various sudden problems'
                        },
                    ],
                },
                {
                    id: 3,
                    zw_title: 'Intern',
                    job_place: 'Shanghai',
                    send_email: 'janeca@eastrongintl.com',
                    job_duties: [
                        {key: 1, value: 'Collate the documents'},
                        {key: 2, value: 'System data entry'},
                        {key: 3, value: 'Collation of other documents'},
                    ],
                    job_condition: [
                        {key: 1, value: 'Work carefully and patiently'},
                        {
                            key: 2,
                            value: 'Strong communication skill, proficient in Microsoft Office Suite, including Microsoft Outlook'
                        },
                        {key: 3, value: 'College students working at least three days a week'},
                        {
                            key: 4,
                            value: 'Basic salary + double salary at the end of the year + performance bonus + paid training + various subsidies'
                        },
                        {key: 5, value: 'Opportunity of promotion'},
                        {
                            key: 6,
                            value: 'Colorful staff activities, regular arrangement of physical examinations, excellent team dinners, tourism and other activities, casual working atmosphere and excellent corporate culture'
                        },
                    ],
                }
            ],
        }
    }
}
</script>
<style lang="less">
.join_us_en_div {
  background: #f7f7f7;

  .join_banner {
    width: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .join_dz_title {
    display: flex;
    justify-content: center;

    .join_dz_img {
      // margin: 70px 0 30px 0;
      // border: 1px  dashed #999;
      // img{
      //     width:100%;
      //     height:100%;
      // }
      margin: 50px 0 30px 0;
      font-size: 30px;
      font-weight: 700;

      .line_div_box {
        background: #2200ba;
        width: 30px;
        height: 4px;
        margin: auto;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .filtrate_div {
    display: flex;
    // justify-content: space-around;
    margin: 30px 0 50px 0;

    .workplace_style {
      margin-right: 80px;
    }
  }

  .table_job_div {
    padding: 20px 0 80px 0;

    .job_box {
      background: #f2f2f2;
      padding: 20px 0 20px 50px;
      font-size: 18px;
      font-weight: bold;
      border: 1px solid #dcdee2;

      span {
        width: 17%;
        display: inline-block;
        text-align: center;
      }

      span:nth-child(2) {
        margin: 0 20%;
      }
    }

    .collapse_box {
      .panel_s {
        .ivu-collapse-header {
          height: 0px !important;
          line-height: 0px !important;
          padding: 20px 0 30px 16px !important;
        }

        .title_span_s {
          b {
            font-weight: normal;
            font-size: 16px;
            width: 19%;
            display: inline-block;
            text-align: center;
          }

          b:nth-child(2) {
            margin: 0 16%;
          }
        }

        .join_job_duty_condition_box {
          padding-left: 15px;
          font-size: 14px;
          line-height: 40px;
          color: #3F3F3F;
          display: flex;
          justify-content: space-between;
          margin: 8px 0 30px 0;

          .duty_condition_title {
            font-size: 16px;
          }

          .join_left {
            width: 45%;
          }

          .join_right {
            width: 45%;
          }
        }
      }
    }
  }

  .table_job_div_mobile {
    display: none;
  }

  .join_content {
    margin: 20px 0 30px 0;

    .join_con_div {
      border-bottom: 1px solid #cccccc;
      padding: 30px 50px 0 50px;

      .join_job_title_box {
        line-height: 60px;
        border-bottom: 1px dashed #999;

        .join_job_title {
          display: flex;
          font-size: 22px;
          line-height: 22px;

          .join_line_div {
            width: 4px;
            height: 22px;
            background: #2200ba;
            margin: 0 15px 0 0;
          }
        }

        .join_workplace_email_div {
          margin: 0 0 0 15px;
          font-size: 16px;

          .join_workplace_text {
            margin-right: 60px;
          }
        }
      }

      .join_job_duty_condition_box {
        padding-left: 15px;
        font-size: 14px;
        line-height: 40px;
        color: #3F3F3F;
        display: flex;
        justify-content: space-between;
        margin: 8px 0 30px 0;

        .duty_condition_title {
          font-size: 16px;
        }

        .join_left {
          width: 45%;
        }

        .join_right {
          width: 45%;
        }
      }
    }

    .join_con_div:last-child {
      border-bottom: none;
    }
  }
}

@media screen and (max-width: 900px) {
  .join_us_en_div {
    .table_job_div {
      display: none;
    }

    //筛选条件
    .filtrate_div {
      flex-direction: column;

      div {
        span {
          width: 110px;
          display: inline-block;
          text-align: right;
        }

        .ivu-select {
          width: 200px !important;
        }
      }

      .workplace_style {
        margin-bottom: 15px;
      }
    }

    //折叠面板相关内容
    .table_job_div_mobile {
      display: block;
      padding: 20px 0 80px 0;

      .job_box { //表头
        background: #f2f2f2;
        padding: 20px 0 20px 50px;
        font-size: 16px;
        font-weight: bold;
        border: 1px solid #dcdee2;

        span {
          width: 40%;
          display: inline-block;
          text-align: center;
        }

        span:nth-child(2) {
          margin: 0 10%;
        }
      }

      .collapse_box {
        .panel_s {
          .ivu-collapse-header {
            height: 0px !important;
            line-height: 0px !important;
            padding: 20px 0 30px 16px !important;
          }

          .title_span_s {
            b {
              font-weight: normal;
              font-size: 16px;
              width: 60%;
              display: inline-block;
              text-align: center;
            }

            // b:nth-child(2){
            //     margin: 0 20%;
            // }
          }

          .email_div {
            margin: 20px 0;
          }

          .join_job_duty_condition_box {
            padding-left: 15px;
            font-size: 14px;
            line-height: 40px;
            color: #3F3F3F;
            flex-direction: column;
            margin: 8px 0 30px 0;

            .duty_condition_title {
              font-size: 16px;
            }

            .join_left {
              width: 100%;
            }

            .join_right {
              width: 100%;
            }
          }
        }
      }

    }

    .join_content {
      .join_con_div {
        padding: 30px 20px 0 20px;

        .join_job_title_box {
          .join_workplace_email_div {
            display: flex;
            flex-direction: column;
          }
        }

        .join_job_duty_condition_box {
          display: flex;
          flex-direction: column;

          .join_left {
            width: 100%;
          }

          .join_right {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
